module.exports = __webpack_public_path__ + "img/btn-prev.5d59b5e0.png";